import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { GetResponseDiscordBot } from '../../models/discord-bot.interface';

@Injectable({
  providedIn: 'root',
})
export class DiscordBotService {
  apiAddress: string = environment.apiAddress;

  constructor(private http: HttpClient) {}

  postBotDiscord(botId: string, server_id: number, is_enabled: boolean, server_name?: string) {
    return this.http.post<any>(`${this.apiAddress}/bot/${botId}/discord_bot`, {
      server_id,
      is_enabled,
      server_name,
    });
  }

  getBotDiscord(botId: string) {
    return this.http.get<GetResponseDiscordBot>(`${this.apiAddress}/bot/${botId}/discord_bot`);
  }

  updateBotDiscord(
    botId: string,
    is_enabled: boolean,
    server_id?: number,
    channel_name?: string,
    server_name?: string
  ) {
    const body = {
      is_enabled: is_enabled,
      server_id: server_id,
      channel_name: channel_name,
      server_name: server_name,
    };
    return this.http.put<any>(`${this.apiAddress}/bot/${botId}/discord_bot`, body);
  }
}
